import { Typography, Checkbox } from "@material-tailwind/react";
import { Button, Tooltip } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  getClientURL,
  verifyPeopleTraining,
} from "./../../helperFunctions/apiFunction";
import { useAuthUserToken } from "./../../hooks/useAuthUserToken";

const PeopleTrainingPdfView = ({ setPdfView, pdfData, peopleId }) => {
  const { refreshToken } = useAuthUserToken();
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isLoadingFile, setIsLoadingFile] = useState(true);
  const [fileUrl, setFileUrl] = useState("");
  const [formData, setFormData] = useState({
    peopleIds: "",
    trainingId: "",
    assignedTrainingId: "",
  });

  useEffect(() => {
    getClientURL(refreshToken, pdfData?.training?.trainingFile)
      .then((response) => {
        setFileUrl(response?.fileUrl);
      })
      .catch((error) => {
        toast.error(error?.message, {
          className: "text-[12px]",
        });
        console.error("Error during login:", error);
      })
      .finally(() => {
        setIsLoadingFile(false);
      });
  }, []);
  useEffect(() => {
    if (pdfData.status === "completed") {
      setIsChecked(true);
      setFormData({
        peopleIds: "",
        trainingId: "",
        assignedTrainingId: "",
      });
    }
  }, [pdfData]);

  const handleCheckboxChange = () => {
    if (pdfData?.status === "pending") {
      setIsChecked((cur) => !cur);
      setFormData({
        trainingId: pdfData?.training?.id,
        peopleId: peopleId,
        assignedTrainingId: pdfData?._id,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isChecked) {
      setIsLoadingButton(true);
      verifyPeopleTraining(refreshToken, formData)
        .then((response) => {
          if (response?.code === 200 || response?.code === 201) {
            toast.success(response.message, {
              className: "text-[12px]",
            });
          } else if (response.code === 400 || response?.code === 404) {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          } else {
            toast.error(response?.message, {
              className: "text-[12px]",
            });
          }
        })
        .catch((error) => {
          toast.error("Something went wrong!", {
            className: "text-[12px]",
          });
          console.error("Error during login:", error);
        })
        .finally(() => {
          setFormData({
            peopleIds: "",
            trainingId: "",
            assignedTrainingId: "",
          });
          setIsLoadingButton(false);
          setPdfView(false);
          setIsChecked(false);
        });
    }
  };

  return (
    <div className="flex justify-between items-stretch p-4">
      <div className="p-3 bg-gray-200 rounded-sm drop-shadow-lg w-1/3">
        <div className="border border-gray-300 rounded-md p-3 mb-4 bg-white">
          <Typography
            color="blue-gray"
            variant="h4"
            className="font-bold text-lg text-center capitalize"
          >
            {pdfData?.training?.trainingTitle}
          </Typography>
        </div>
        <div className="border border-gray-300 rounded-md p-4 mb-4 bg-white">
          <div className="flex items-center gap-2">
            <Checkbox
              id="ripple-on"
              ripple={true}
              checked={isChecked}
              disabled={pdfData.status === "completed"}
              onChange={handleCheckboxChange}
            />
            <Typography color="gray" variant="p" className="mt-1 font-normal">
              I confirm that I have reviewed the training and approved its
              contents.
            </Typography>
          </div>
          <div className="flex items-center justify-between p-4 gap-4">
            <Button
              variant="text"
              color="red"
              onClick={() => {
                setPdfView(false);
                setFormData({
                  peopleIds: "",
                  trainingId: "",
                  assignedTrainingId: "",
                });
              }}
            >
              <span>Back</span>
            </Button>
            {pdfData?.status === "pending" ? (
              <Button
                variant="gradient"
                type="submit"
                color="green"
                disabled={!isChecked}
                loading={isLoadingButton}
                onClick={handleSubmit}
              >
                <span>Submit</span>
              </Button>
            ) : (
              <Tooltip className="bg-blue-gray-500" content="Already Submitted">
                <Button
                  variant="gradient"
                  type="submit"
                  color="green"
                  disabled={true}
                >
                  <span>Submitted</span>
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      {isLoadingFile ? (
        <>
          <div className="align-items-center flex justify-center w-100">
            <div class="w-16 h-16 border-8 border-dashed rounded-full animate-spin border-blue-600"></div>
          </div>
        </>
      ) : (
        <>
          <div className="w-full min-h-screen flex flex-col">
            <iframe
              src={fileUrl}
              title="PDF Viewer"
              className="flex-grow"
              width="100%"
              height="100%"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PeopleTrainingPdfView;
